import { render, staticRenderFns } from "./AppHighlightsPlaystoreRating.vue?vue&type=template&id=734d6d53&"
import script from "./AppHighlightsPlaystoreRating.vue?vue&type=script&lang=js&"
export * from "./AppHighlightsPlaystoreRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports